module.exports = __webpack_public_path__ + "static/media/bf4.79a5e53f.png";